import jump from 'jump.js';
import {scrollIt} from './../library/scrollit'
    window.addEventListener('scroll', function() {
        // var scrollactual = window.pageYOffset;
        // export default scrollactual;
        const menufix = document.querySelector('.headerfix')
        const scrollup = document.querySelector('.scrollup')
        const scrollupbtn = document.querySelector('.scrollup img')
        const header = document.querySelector('header')
        // if(scrollup){
            scrollupbtn.addEventListener('click', ()=>{
                // jump(header, {
                //     // offset: -30
                // });
                scrollIt(header, 300, 'easeOutQuad',() => console.log(`Just finished scrolling to ${window.pageYOffset}px`))
            });
        // }

        if(window.scrollY>200){

          

            if(menufix){
                menufix.classList.add('active');
            }
            if(scrollup){
                scrollup.classList.add('active');
            }

        } else
        {
            if(menufix){
                menufix.classList.remove('active');
            }
            if(scrollup){
                scrollup.classList.remove('active');
            }

        }
    });

